import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const boolInputBase = css`
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: ${theme.zIndex.low};
`;

export const boolInputEnabled = css`
  cursor: pointer;
`;

export const boolInputDisabled = css`
  cursor: not-allowed;
`;
